document.addEventListener('DOMContentLoaded', function () {
  // Com suporte a animação ligada ao scroll, o CSS faz tudo no compositor.
  // Este script fica só como reserva para navegadores sem suporte.
  if (window.CSS && CSS.supports && CSS.supports('animation-timeline: view()')) return;

  document.querySelectorAll('[data-hero-banner]').forEach(function (root) {
    var heroWrap = root;
    var heroSticky = root.querySelector('.hero-scroll-sticky');
    var heroImgs = root.querySelectorAll('.hero-media-link img');
    var heroCta = root.querySelector('.hero-cta');
    var heroScrollHint = root.querySelector('.hero-scroll-hint');
    var ticking = false;
    var lastProgress = -1;

    function updateHero() {
      ticking = false;
      var rect = heroWrap.getBoundingClientRect();
      // Altura do palco fixo, e não innerHeight: o palco usa svh, e innerHeight
      // muda quando a barra do Safari aparece/some, o que fazia o efeito pular.
      var stageHeight = heroSticky ? heroSticky.offsetHeight : window.innerHeight;
      var scrollableDistance = heroWrap.offsetHeight - stageHeight;
      var progress = scrollableDistance > 0 ? -rect.top / scrollableDistance : 1;
      progress = Math.min(Math.max(progress, 0), 1);

      // Fora do trecho fixado nada muda: não reescreve estilo à toa.
      if (progress === lastProgress) return;
      lastProgress = progress;

      var scale = 1 + progress * 0.15;
      var imgOpacity = progress < 0.55 ? 1 : Math.max(0, 1 - (progress - 0.55) / 0.35);
      heroImgs.forEach(function (img) {
        img.style.transform = 'scale(' + scale + ')';
        img.style.opacity = imgOpacity;
      });

      if (heroCta) {
        var ctaOpacity = progress < 0.5 ? 0 : Math.min(1, (progress - 0.5) / 0.4);
        heroCta.style.opacity = ctaOpacity;
        heroCta.style.transform = 'translate(-50%, ' + (-46 + ctaOpacity * 6) + '%)';
        heroCta.classList.toggle('is-active', ctaOpacity > 0.5);
      }
      if (heroScrollHint) {
        heroScrollHint.style.opacity = Math.max(0, 1 - progress * 4);
      }
    }

    // No máximo um cálculo por quadro, alinhado com a pintura da tela.
    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateHero);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    updateHero();
  });
});
